import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Collapse from '@material-ui/core/Collapse';

import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputControl from '~/components/Input/InputControl';
import LinearProgress from '~/components/LinearProgress';
import InputSelect from '~/components/Input/InputSelect';
import InputSwitch from '~/components/Input/InputSwitch';
import InputNumber from '~/components/Input/InputNumber';
import InputCheckBox from '~/components/Input/InputCheckBox';

import CorporationPaymenetServiceRecord from '~/records/CorporationPaymenetServiceRecord';
import Request from '~/providers/Request';

const attrName = (attr) =>
  CorporationPaymenetServiceRecord.hummanAttributeName(attr);

function Form({ record, handleChange, loading }) {
  const [paymentServiceOptions, setPaymentServiceOptions] = useState([]);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [paymentWalletOptions, setPyamentWalletOptions] = useState([]);

  const fetchPaymentServices = () => {
    Request.get('/admin/payment_services', null, { normalizeJSON: true })
      .then((response) => {
        setPaymentServiceOptions(response.data);
      })
      .catch((e) => {
        console.log(e);
        setPaymentServiceOptions([]);
      });
  };

  const fetchPaymentMethods = () => {
    Request.get('/admin/payment_methods', null, { normalizeJSON: true })
      .then((response) => {
        setPaymentMethodOptions(response.data);
      })
      .catch((e) => {
        console.log(e);
        setPaymentMethodOptions([]);
      });
  };

  const fetchPaymentWallets = () => {
    Request.get('/admin/payment_wallets', null, { normalizeJSON: true })
      .then((response) => {
        setPyamentWalletOptions(response.data);
      })
      .catch((e) => {
        console.log(e);
        setPyamentWalletOptions([]);
      });
  };

  useEffect(() => {
    fetchPaymentServices();
    fetchPaymentMethods();
    fetchPaymentWallets();
  }, []);

  return (
    <>
      <LinearProgress loading={loading} />
      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputControl
            label={attrName('payment_service')}
            value={record.get('payment_service')}
            name={'payment_service'}
            inputComponent={InputSelect}
            onChange={handleChange}
            InputProps={{
              isClearable: true,
              options: paymentServiceOptions,
              outValueType: 'object',
            }}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputControl
            label={attrName('payment_wallet')}
            value={record.get('payment_wallet')}
            name={'payment_wallet'}
            inputComponent={InputSelect}
            onChange={handleChange}
            InputProps={{
              isClearable: true,
              options: paymentWalletOptions,
              outValueType: 'object',
            }}
          />
        </GridItem>

        <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
          <InputControl
            label={attrName('payment_method')}
            value={record.get('payment_method')}
            name={'payment_method'}
            inputComponent={InputSelect}
            onChange={handleChange}
            InputProps={{
              isClearable: true,
              options: paymentMethodOptions,
              outValueType: 'object',
            }}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputControl
            value={record.get('price')}
            name="price"
            label={attrName('price')}
            inputComponent={InputNumber}
            InputProps={{
              config: { allowDecimal: true, requireDecimal: true },
            }}
            onChange={handleChange}
          />
        </GridItem>

        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputControl
            value={record.get('is_include_corporation_branches')}
            name="is_include_corporation_branches"
            label={attrName('is_include_corporation_branches')}
            inputComponent={InputCheckBox}
            onChange={handleChange}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
          <InputSwitch
            label={attrName('is_fixed')}
            name={'is_fixed'}
            value={record.get('is_fixed')}
            onChange={(value) => handleChange({ is_fixed: value })}
          />
        </GridItem>
      </GridContainer>

      <Collapse in={record.get('is_fixed')} timeout="auto" unmountOnExit>
        <GridContainer>
          <>
            <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
              <InputControl
                value={record.get('fixed_amount')}
                name="fixed_amount"
                label={attrName('fixed_amount')}
                inputComponent={InputNumber}
                InputProps={{
                  config: { allowDecimal: false, requireDecimal: false },
                }}
                onChange={handleChange}
              />
            </GridItem>
            <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
              <InputControl
                value={record.get('excess_price')}
                name="excess_price"
                label={attrName('excess_price')}
                inputComponent={InputNumber}
                InputProps={{
                  config: { allowDecimal: true, requireDecimal: true },
                }}
                onChange={handleChange}
              />
            </GridItem>
          </>
        </GridContainer>
      </Collapse>
      <LinearProgress loading={loading} />
    </>
  );
}

Form.propTypes = {
  loading: PropTypes.bool,
  record: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

Form.defaultProps = {
  loading: false,
};
export default Form;
